import { z } from "zod";

export const SearchSchema = z.object({
  traceableAppId: z.string().optional(),
});
